/**
 * @flow
 * @relayHash 041b5c0ca60ef80468e8b317a07e1a85
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type sharedBookPage_sharedBook$ref = any;
export type srcSharedBookQueryVariables = {|
  slug: string
|};
export type srcSharedBookQueryResponse = {|
  +sharedBook: {|
    +$fragmentRefs: sharedBookPage_sharedBook$ref
  |}
|};
export type srcSharedBookQuery = {|
  variables: srcSharedBookQueryVariables,
  response: srcSharedBookQueryResponse,
|};
*/


/*
query srcSharedBookQuery(
  $slug: String!
) {
  sharedBook(slug: $slug) {
    ...sharedBookPage_sharedBook
  }
}

fragment sharedBookPage_sharedBook on SharedBook {
  slug
  title
  coverImage
  coverImageAlt
  downloadSize
  downloadType
  downloadURL
  purchaseURL
  contactEmail
  contactSubject
  password
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcSharedBookQuery",
  "id": null,
  "text": "query srcSharedBookQuery(\n  $slug: String!\n) {\n  sharedBook(slug: $slug) {\n    ...sharedBookPage_sharedBook\n  }\n}\n\nfragment sharedBookPage_sharedBook on SharedBook {\n  slug\n  title\n  coverImage\n  coverImageAlt\n  downloadSize\n  downloadType\n  downloadURL\n  purchaseURL\n  contactEmail\n  contactSubject\n  password\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcSharedBookQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sharedBook",
        "storageKey": null,
        "args": v1,
        "concreteType": "SharedBook",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "sharedBookPage_sharedBook",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcSharedBookQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sharedBook",
        "storageKey": null,
        "args": v1,
        "concreteType": "SharedBook",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "coverImage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "coverImageAlt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "downloadSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "downloadType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "downloadURL",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "purchaseURL",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactSubject",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "password",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6b0681c3c27e443a4f2fcc396715fd0c';
module.exports = node;
